import React, {useState, useContext, useEffect} from "react";
import { useTranslation } from 'react-i18next';
import { BreadcrumbContext } from '../../../components/Breadcrumb';
import { FirebaseAuth } from "../../../components/FirebaseAuth/firebase";
import { useNavigate, Navigate } from 'react-router-dom';
import Loader from '../../../components/Loader';
import AddIcon from '@mui/icons-material/Add';
import { Card, Button, CardActions, Grid, CardHeader, CardContent, Typography, Box } from "@mui/material";

const Home = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { setBreadcrumb } = useContext(BreadcrumbContext);

    const [loading, setLoading] = useState(true);
    const [accounts, setAccounts] = useState([]);

    useEffect(() => {
        setBreadcrumb([
            {
                to: "/",
                text: t('common.home'),
                active: false
            },
            {
                to: null,
                text: t('home.title'),
                active: true
            }
        ]);

        let cancelled = false;
        setLoading(true);
        const accountsRef = FirebaseAuth.firestore().collection('accounts');
        const query = accountsRef.where('access', 'array-contains', FirebaseAuth.auth().currentUser.uid);
        query.get().then(accountSnapshots => {
            if (cancelled) return;
            let records = [];
            accountSnapshots.forEach(account => {
                if(account.data().subscriptionStatus !== 'canceled'){
                    records.push({
                        'id': account.id,
                        'name': account.data().name,
                        'subscriptionStatus': account.data().subscriptionStatus
                    });
                }
            });
            setAccounts(records);
            setLoading(false);
        });

        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[setBreadcrumb, t]);

    return (
        <>
            {accounts.length > 0 ? (
                <>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
                        <Button onClick={() => navigate('/new-project')} color="primary" variant="contained" startIcon={<AddIcon />}>
                            {t('home.addProject')}
                        </Button>
                    </Box>
                    <Grid container spacing={3}>
                    {accounts.map((account, i) =>
                        <Grid container item xs={12} md={3} key={i}>
                            <Card
                                key={account.id}
                                sx={{
                                    width: '100%',
                                    backgroundColor: (theme) => theme.custom.card,
                                    boxShadow: (theme) => theme.custom.cardShadow,
                                    border: (theme) => `1px solid ${theme.custom.border}`,
                                }}
                            >
                                <CardHeader title={account.name} />
                                <CardContent>
                                    <Typography variant="body2" sx={{ color: (theme) => theme.custom.muted }}>
                                        <strong>{t('home.idLabel')}:</strong> <small>{account.id}</small>
                                    </Typography>
                                </CardContent>

                                <CardActions>
                                    {account.subscriptionStatus?(
                                        <Button size="small" color="primary" onClick={() => navigate('/account/'+account.id+'/')}>{t('home.viewDashboards')}</Button>
                                    ):(
                                        <Button size="small" color="warning" onClick={() => navigate('/account/'+account.id+'/billing/plan')}>{t('home.activateProject')}</Button>
                                    )}
                                </CardActions>
                            </Card>
                        </Grid>
                    )}
                    </Grid>
                </>
            ) : (
                <>
                    {(loading) ? (
                        <Loader text={t('home.loadingProjects')}></Loader>
                    ):(
                        <Navigate to="/new-project" replace />
                    )}
                </>
            )}
        </>

    )
}

export default Home;
